<template>
  <section
    v-for="author in authors"
    :key="author.slug"
    class="section page-author-block"
    :aria-labelledby="`page-author-${author.slug}-name`"
  >
    <div class="section-inner section-contained">
      <p v-if="introLabel" class="page-author-block-intro size-s">
        {{ introLabel }}
      </p>
      <article class="staff-testimonial parent-bg collection-tabs-item">
        <div class="staff-testimonial--header">
          <nuxt-img
            v-if="author.photo?.filename"
            :src="author.photo.filename"
            :alt="author.full_name"
            class="staff-testimonial--photo"
            provider="storyblok"
            width="108"
            height="108"
          />
          <div class="staff-testimonial--text size-xs">
            <div class="page-author-block-name-row">
              <p
                :id="`page-author-${author.slug}-name`"
                class="staff-testimonial--name size-m bold"
              >
                {{ author.full_name }}
              </p>
              <a
                v-if="author.url_linkedin"
                :href="author.url_linkedin"
                class="page-author-block-link"
                target="_blank"
                rel="noopener noreferrer"
                :aria-label="linkedinAriaLabel(author.full_name)"
              >
                <SvgIcon
                  name="func_linkedin"
                  class="page-author-block-link-icon"
                  aria-hidden="true"
                />
              </a>
            </div>
            <p v-if="author.job_title" class="staff-testimonial--job-title">
              {{ author.job_title }}
            </p>
            <p v-if="author.short_bio" class="staff-testimonial--bio">
              {{ author.short_bio }}
            </p>
          </div>
        </div>
      </article>
    </div>
  </section>
</template>

<script setup>
defineProps({
  authors: {
    type: Array,
    required: true,
  },
});

const introLabel = useMicroCopy("author.block.intro");

const linkedinAriaLabel = (name) =>
  useMicroCopy("author.block.linkedin.aria-label", { name }) ||
  `LinkedIn - ${name}`;
</script>

<style lang="scss" scoped>
.page-author-block-intro {
  margin-bottom: 1.5rem;
}

.page-author-block-name-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-wrap: wrap;
  margin-bottom: 0.5rem;

  @include for-tablet-landscape-up {
    justify-content: flex-start;
  }
}

.page-author-block-link {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  text-decoration: none;
}

.page-author-block-link-icon {
  width: 1.25rem;
  height: 1.25rem;
}

.staff-testimonial {
  display: flex;
  flex-direction: column;
  padding: 2.5rem col-span();
  border-radius: $radius-m;
  @include pair-1;
  @include for-tablet-landscape-up {
    padding: 4.5rem col-span(3) 4.5rem col-span();
  }
  @include for-desktop-up {
    padding-right: col-span(2);
  }

  &--header {
    display: flex;
    gap: 1rem;
    flex-direction: column;
    align-items: center;
    text-align: center;
    @include for-tablet-landscape-up {
      flex-direction: row;
      margin-left: col-span(2);
      align-items: center;
      text-align: left;
      gap: 2rem;
    }
    @include for-desktop-up {
      margin-left: col-span(1);
    }
    :deep(img) {
      max-width: 5.625rem;
      border-radius: $radius-m;
      @include for-tablet-landscape-up {
        max-width: 6.75rem;
      }
    }
  }

  &--name {
    color: var(--brand);
    margin-bottom: 0;
  }
}
</style>

<style lang="scss">
.facility-news .page-author-block .staff-testimonial {
  @include pair-3;
}

.alternate .page-author-block .staff-testimonial {
  @include pair-7;
}
</style>
